import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccessYetComponent } from './access-yet.component';

@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: AccessYetComponent }
    ])],
    exports: [RouterModule]
})
export class AccessYetRoutingModule {}
